import { Theme } from '../../../types/filter'
import { millisToMinutesAndSeconds } from '../../../utils/shared'
import { Okn } from '../../../types/hub/objective'
const getLearnersCount = (data: any) => {
  return data?.nbr_student || 0
}
const getSkillsCount = (data: any) => {
  return data?.nbr_knowledge_nodes || 0
}

const getAvgPositionings = (data: any) => {
  return data?.avg_nbr_positionings || 0
}

const getDetailsBySkillWithOkn = (data: any, okns: Okn[]) => {
  const knowledgeNodesOfTheme = data?.knowledge_nodes || []

  // find and add kn name
  return knowledgeNodesOfTheme.map(elem => {
    const kn = okns.filter(okn => okn.knowledge_node.uid === elem.uid)[0]

    return {
      ...elem,
      label: kn?.knowledge_node.name,
      nb_levels: kn?.knowledge_node.nb_levels || 0 // fallback to 0 if no nb_levels
    }
  })
}
const getMultiGraphDatas = (data: any, okns: Okn[]) => {
  return getDetailsBySkillWithOkn(data, okns).map(elem => {
    return { label: elem?.label || '', value: elem?.values?.perc_students_validation || 0 }
  })
}

const getTimePerPositionning = (time: number) => {
  return millisToMinutesAndSeconds(time)
}

const getMaxScale = (okns: Okn[]) => {
  return Math.max(...okns.map(okn => okn.knowledge_node.nb_levels)) ?? 5
}

// 🚨 Radar data
const getSkillsOfSelectedObjective = (
  data: any,
  selectedTheme: Theme,
  isRiseup: boolean,
  okns: Okn[]
) => {
  // 👇 we don't have validation level data for all themes than
  //  step 1 => verify we have a validation level for all themes
  if (data?.knowledge_nodes || okns.length > 0) {
    // get skills of theme
    const skillsOfTheme = getDetailsBySkillWithOkn(data, okns)

    let isDisplayFinalLevel = false
    let isDisplayInitLevel = false
    const isTherotical = isRiseup ? false : selectedTheme.attempt_options?.workflow === null

    const maxScale = getMaxScale(okns)

    const getValue = (index: number, level: string) => {
      let value = data?.knowledge_nodes[index]?.values?.avg_kn_levels[level]
      if (value === null) {
        value = -4
      }

      return value
    }

    const radarData = skillsOfTheme
    .sort((a: any, b: any) => a.label.localeCompare(b.label)) // sort by label alphabetically
    .map((skill, index) => {
      // find name of skill from skills array
      const nameOfSkill = skill.label
      // calculte initial, actual and target levels

      const skillScale = skill.nb_levels

      // transform value  from [-4+4] to [0 8]
      const getLevel = (index: number, level: string) => {
        const value = getValue(index, level)

        return ((value + 4) * (skillScale + 1)) / 8
      }

      const initialLevel = getLevel(index, 'initial_level')

      if (getValue(index, 'initial_level')) {
        isDisplayInitLevel = true
      }
      let actualLevel = null as null | number

      if (isTherotical) {
        actualLevel = getLevel(index, 'estimated_level')
      } else {
        actualLevel = getLevel(index, 'final_level')
      }

      if (getValue(index, 'final_level') || getValue(index, 'estimated_level')) {
        isDisplayFinalLevel = true
      }

      const targetLevel = getLevel(index, 'threshold_level')

      const normalizeLevel = (level: number, scale: number) => {
        return (level / scale) * maxScale
      }

      return {
        subject: nameOfSkill,
        initialLevel: normalizeLevel(initialLevel, skillScale),
        actualLevel: normalizeLevel(actualLevel, skillScale),
        targetLevel: normalizeLevel(targetLevel, skillScale)
      }
    })

    return {
      scale: maxScale,
      radarData,
      isDisplayFinalLevel,
      isDisplayInitLevel,
      isTherotical
    }
  } else {
    // no data for this theme
    return {
      radarData: [],
      isDisplayFinalLevel: true,
      isDisplayInitLevel: true
    }
  }
}

const getBarComparisonData = (data: any, graph?: string) => {
  let progress1 = 0
  let progress2 = 0

  if (data) {
    if (graph === 'answeredQuestions') {
      progress1 = data?.avg_first_positioning_nbr_questions
      progress2 = data?.avg_last_positioning_nbr_questions
    } else {
      progress1 = data?.avg_first_positioning_time
      progress2 = data?.avg_last_positioning_time
    }
  }
  return [
    { progress: progress1, legend: 'Initial' },
    { progress: progress2, legend: 'Final' }
  ]
}

const getPercComparisonData = (data: any, graph?: string) => {
  let progress1 = 0
  let progress2 = 0
  if (data) {
    if (graph === 'correctAnswers') {
      progress1 = data?.avg_first_positioning_perc_correct_answers
      progress2 = data?.avg_last_positioning_perc_correct_answers
    } else {
      progress1 = data?.avg_first_positioning_perc_validated_kn
      progress2 = data?.avg_last_positioning_perc_validated_kn
    }
  }

  return {
    innerCircle: {
      progress: progress1,
      legend: 'Initial'
    },
    outerCircle: {
      progress: progress2,
      legend: 'Final'
    }
  }
}

export {
  getTimePerPositionning,
  getLearnersCount,
  getAvgPositionings,
  getMultiGraphDatas,
  getSkillsOfSelectedObjective,
  getPercComparisonData,
  getBarComparisonData,
  getSkillsCount
}
